export default __webpack_public_path__ + "static/media/pool-vehicle-res.f169ea09.svg";